<template>
	<v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.mobile ? '100%' : '30%'" persistent>
		<v-card class="justify-center text-center card-rounded pb-5">
			<v-card-title class="pa-2 white--text justify-center text-center accent">
				<v-spacer />
				Chat with {{ this.receiverData.name }}
				<v-spacer />
				<v-icon icon @click="GetConversationMessages">mdi-refresh</v-icon>
				<v-icon icon @click="close">mdi-close</v-icon>
			</v-card-title>
			<div ref="messageContainer" :style="'max-height:' + ($vuetify.breakpoint.mobile ? '425px' : '500px')" class="scrollable-card-text">
				<div v-for="message in messages" :key="message.id">
					<v-card-text>
						<v-row :justify="message.sentByID === receiverData.id ? 'start' : 'end'">
							<v-col md="8">
								<v-card
									:class="message.sentByID === receiverData.id ? 'text-left rounded-r-xl' : 'text-left rounded-l-xl'"
									style="color: white"
									:color="message.sentByID === receiverData.id ? 'green' : 'accent'"
								>
									<v-row>
										<v-col :cols="message.sentByID === receiverData.id ? '11' : '10'" style="margin-left: 1rem">
											<div justify="left" :class="'white--text'">{{ message.message }}</div>
										</v-col>
										<v-col v-if="message.sentByID !== receiverData.id" cols="1">
											<div class="d-flex align-end justify-end" style="height: 100%">
												<img v-if="message.isSeen === true" class="white--text align-end" height="16" :src="require('../../assets/icons/read_ticks.svg')" />
												<img
													v-else-if="message.isSeen === false"
													class="white--text align-end"
													height="15"
													:src="require('../../assets/icons/unread_ticks.svg')"
												/>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
					<!-- <v-card-text> -->
					<v-card-text :style="(message.sentByID === receiverData.id ? 'text-align: left' : 'text-align: right') + '; padding-top:0.1rem; padding-bottom: 1rem;'">{{
						formatMessageDateTime(message.createdAt)
					}}</v-card-text>
					<!-- </v-card-text> -->
				</div>
			</div>
			<v-card-actions>
				<div style="display: flex; flex-direction: row; width: 100%">
					<div style="flex-basis: 90%; margin-left: 1rem">
						<v-text-field
							v-model="sendMessage"
							placeholder="Type a message..."
							color="green"
							class="pa-4 bg-green rounded-s-xl rounded-e-xl"
							style="background-color: #f5f5f5; border-radius: 10px"
							@keyup.enter="onSend()"
						></v-text-field>
					</div>
					<div style="flex-basis: 10%; display: flex; justify-content: center; align-items: center">
						<v-btn :disabled="sendMessage === null || sendMessage.match(/^ *$/) !== null" class="mx-2" fab color="accent" size="small" @click="SendMessage"
							><v-icon>mdi-send</v-icon>
						</v-btn>
					</div>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import store from '@/store';
import { bus } from '@/main';
import moment from 'moment';
export default {
	name: 'MessageDialog',
	props: {},

	data() {
		return {
			dialog: false,
			practiceName: null,
			practiceBussinessEmail: null,
			professionTitle: null,
			monthlySalary: null,
			workingHours: null,
			valid: false,
			receiverData: {},
			messages: [],
			sendMessage: '',
			sentByID: '',
		};
	},
	computed: {
		company() {
			return store.getters.company || {};
		},
		user() {
			return store.getters.user || {};
		},
		validForm() {
			return this.valid && !!this.practiceBussinessEmail && !!this.professionTitle && !!this.monthlySalary && !!this.workingHours;
		},
	},

	mounted() {
		const { name, email } = this.company;
		this.practiceName = name;
		this.practiceBussinessEmail = email;
	},

	methods: {
		...mapActions('message', ['GetMessages', 'CreateMessage']),
		async open(receiverData, sentByID) {
			this.receiverData = receiverData;
			this.dialog = true;
			this.sentByID = sentByID;
			await this.GetConversationMessages();
			this.scrollToBottom();
		},

		formatMessageDateTime(dateTime) {
			const formattedTime = dateTime.toLocaleString('en-US', {
				hour12: false,
				hour: '2-digit',
				minute: '2-digit',
				timeZone: 'UTC',
			});

			const formattedDate = dateTime.toLocaleString('en-US', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				timeZone: 'UTC',
			});

			const finalFormat = formattedDate.toString().substr(0, 10) + ' ' + formattedTime.toString().substr(11, 5);

			return finalFormat;
		},

		close() {
			this.dialog = false;
		},

		async SubmitForm() {
			// Send mail to LB Admin
			const placementDetails = {
				practiceName: this.practiceName,
				practiceBussinessEmail: this.practiceBussinessEmail,
				professionTitle: this.professionTitle,
				monthlySalary: this.monthlySalary,
				workingHours: this.workingHours,
				message: this.message,
			};
			await this.RequestPermanentPlacement(placementDetails);
			this.close();
		},

		async GetConversationMessages() {
			this.messages = await this.GetMessages({
				receivedByID: this.receiverData.id,
				sentByID: this.sentByID,
			});
			this.scrollToBottom();
			bus.$emit('refresh-total-unread-message-count');
		},

		async SendMessage() {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');

			const messageItem = {
				receivedByID: this.receiverData.id,
				message: this.sendMessage,
				createdAt: moment(`${dateString}T${new Date().toString().substr(16, 8)}.000Z`).format(),
				sentByID: this.sentByID,
			};

			await this.CreateMessage({
				messageItem,
			});

			this.sendMessage = '';

			await this.GetConversationMessages();
			this.scrollToBottom();
		},

		scrollToBottom() {
			// Get the ref to the message container
			const messageContainer = this.$refs.messageContainer;

			// Scroll to the bottom
			messageContainer.scrollTop = messageContainer.scrollHeight;
		},

		async onSend() {
			if (this.sendMessage !== null && this.sendMessage.match(/^ *$/) === null) {
				await this.SendMessage();
			}
		},
	},
};
</script>
<style scoped>
.scrollable-card-text {
	overflow-y: auto; /* Enable vertical scrolling */
}
</style>
